import React from 'react';
import SupportChatWorkspace from '../../components/admin/SupportChatWorkspace';

export default function UserSupportChat() {
  return (
    <div className="p-6">
      <h1 className="sr-only">User Support Chat</h1>
      <SupportChatWorkspace user_type="user" title="User Support Chat Workspace" />
    </div>
  );
}
